import { EventsModule } from '../events.module';

/**
 * Moduł wydarzeń składek
 *
 * @export
 * @class EventsFeeModule
 * @extends {EventsModule}
 */
export class EventsFeeModule extends EventsModule {}

export default new EventsFeeModule();
